import { Badge } from '@campai/lib-web/components/new/ui'

type TagBadgesProps = {
    tags: string[]
    size?: 'default' | 'lg'
    className?: string
}

export const TagBadges = ({ tags, size, className }: TagBadgesProps) => {
    if (tags.length === 0) {
        return null
    }

    return (
        <span className={`flex flex-wrap items-center gap-1 ${className || ''}`}>
            {tags.map((tag) => (
                <Badge key={tag} variant="colored" seed={tag.toLowerCase()} size={size}>
                    {tag}
                </Badge>
            ))}
        </span>
    )
}
